
























import Vue, {PropType} from 'vue'

export default Vue.extend({
  name: "ModalWrapper",
  props: {
    className: {
      type: [Object, String]
    },
    id: {
      type: String
    },
    title: {
      type: String
    },
    value:{
      type: Boolean
    },
    formStyle: {
      type: String,
      default: 'secondary'
    },
    btns: {
      type: Boolean,
      default: true
    }
  },
  methods:{
    input(data){
      this.$emit('input',data)
    },
    submit(data){
      this.$emit('submit',data)
    }
  }
})
